module.exports = __webpack_public_path__ + "static/media/allergen_milk.871192d4.871192d4.png";